import { TextSelection } from 'prosemirror-state';
import { splitBlock } from 'prosemirror-commands';
export function customEnterHandlingForCodeBlocks(state, dispatch) {
  let ref = state.selection;
  let $head = ref.$head;
  let $anchor = ref.$anchor;
  let nodeTypes = state.schema.nodes;
  if (!$head.sameParent($anchor)) {
    return false;
  }
  if ($head.parent.type !== nodeTypes.codeBlock) {
    return false;
  }
  let shouldSplit;
  if ($head.nodeAfter !== null) {
    shouldSplit = false;
  } else {
    let previous = $head.nodeBefore;
    let previousIsBreak = previous && previous.type === nodeTypes.hardBreak;
    shouldSplit = previousIsBreak;
    if (previousIsBreak && $head.parentOffset > 1) {
      let nodeBeforePrevious = state.doc.resolve($head.pos - 1).nodeBefore;
      let nodeBeforePreviousIsBreak = nodeBeforePrevious && nodeBeforePrevious.type === nodeTypes.hardBreak;
      shouldSplit = nodeBeforePreviousIsBreak;
    }
  }
  if (shouldSplit) {
    let distanceToDeleteBack = 2;
    return splitBlock(state, tr => {
      tr.delete(state.selection.from - distanceToDeleteBack, state.selection.from);
      if (dispatch) {
        dispatch(tr);
      }
    });
  } else {
    return insertHardBreak(state, dispatch);
  }
}
export function insertHardBreak(state, dispatch) {
  let schema = state.schema;
  let hardBreak = schema.nodes.hardBreak.createAndFill();
  if (hardBreak) {
    let tr = state.tr.insert(state.selection.$to.pos, hardBreak);
    tr.setSelection(TextSelection.create(tr.doc, state.selection.$to.pos + 1));
    if (dispatch) {
      dispatch(tr.scrollIntoView());
    }
    return true;
  }
  return false;
}